import { render, staticRenderFns } from "./CourseStudentAmountPanel.vue?vue&type=template&id=b35bba0c&scoped=true"
import script from "./CourseStudentAmountPanel.vue?vue&type=script&lang=js"
export * from "./CourseStudentAmountPanel.vue?vue&type=script&lang=js"
import style0 from "./CourseStudentAmountPanel.vue?vue&type=style&index=0&id=b35bba0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b35bba0c",
  null
  
)

export default component.exports